import { diffOrderedSets } from './diffOrderedSets';
import { mergeOrderedSetDiffs } from './mergeOrderedSetDiffs';
import { type PatchValue, patchOrderedSet } from './patchOrderedSet';

/**
 * Merge ordered unique keys from base and head, knowing their common ancestors.
 * This functions creates a set of keys, containing all keys from ancestors/base/head, even deleted ones.
 * It uses a complex 3way diff/merge/patch algorithm to produce the keys in the best possible order.
 *
 * The whole approach is based on code from https://github.com/mirkokiefer/diff-merge-patch
 */
export function mergeKeys(ancestor: string[], base: string[], head: string[]): PatchValue[] {
    const diffBase = diffOrderedSets(ancestor, base);
    const diffHead = diffOrderedSets(ancestor, head);

    const mergedDiffs = mergeOrderedSetDiffs(diffBase, diffHead);

    return patchOrderedSet(ancestor, mergedDiffs);
}
